import React from 'react';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import jquery from 'jquery';
import 'popper.js/dist/popper.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import './assets/css/custom.css';

config.autoAddCss = false;

import Layout from "./src/components/Layout";

if (typeof window !== "undefined") {
  window.$ = window.jQuery = jquery;
}

export const wrapPageElement = Layout;
